import { css } from '@emotion/core';
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize, typography } from '@atlaskit/theme';

import { calculateStickyHeaderOffset } from './utils/calculate-header-offset';

export const DiffSetFileWrapper = styled.div<{
  isSingleFileModeActive: boolean;
  hasCommentNav: boolean | undefined;
}>`
  position: relative;
  ${({ isSingleFileModeActive, hasCommentNav }) =>
    isSingleFileModeActive
      ? // For single file mode, we want the file to be nearly as tall as the window, so that when
        // we scroll to the file, the top of the file ends up being next to the sticky header.
        css({
          minHeight: `calc( 100vh - ${calculateStickyHeaderOffset(
            hasCommentNav
          )}px - 256px )`,
        })
      : css({
          marginBottom: `${gridSize() * 1.5}px`,
        })}
`;

// This top offset is a short-term fix to line
// the anchors up just below the sticky header
export const ScrollToAnchor = styled.div<{
  topOffset: number;
  hasCommentNav: boolean | undefined;
}>`
  position: absolute;
  top: -${({ topOffset, hasCommentNav }) => topOffset + calculateStickyHeaderOffset(hasCommentNav)}px;
  left: 0;
`;

export const SettingsHeader = styled.div`
  align-items: center;
  display: flex;
  font-weight: bold;
  justify-content: space-between;
  margin-bottom: ${gridSize() * 2}px;
  margin-top: 0;

  h2 {
    ${typography.h400() as any};
    margin-top: 0;
  }
`;

export const GroupedContainer = styled.div`
  display: flex;
`;
